((angular) => {
  'use strict';

  angular
    .module('App')
    .factory('EventQuestionService', [
      '$q',
      '$http',
      'API',
      'FormRedirectService',
      EventQuestionService,
    ]);

  function EventQuestionService($q, $http, API, FormRedirectService) {
    const list = () => {
      return $http.get(`${API}/event/questions/v2`).then((res) => res.data);
    };

    const hasAnswered = () => {
      return $http
        .get(`${API}/event/questions/has-answered`)
        .then((res) => res.data);
    };

    const certificate = () => {
      FormRedirectService.submit(`${API}/participant/certificate`);
    };

    const save = (questions) => {
      return $http
        .post(`${API}/event/questions/`, questions)
        .then((res) => res.data);
    };

    return {
      list,
      hasAnswered,
      save,
      certificate,
    };
  }
})(angular);
